<template>
  <header class="header text_center clearfix" :class="[isShowHeader ? 'show' : '']" ref="header">
    <img class="header_logo" src="/assets/img/header/logo.png" v-if="isShowLogo" />
    <nav class="header_nav">
      <ul v-if="user.user != null" class="pl-0">
        <li><router-link :to="{ name: 'PageFixed', params: { code: 'latest_deals' } }"><img src="/assets/img/header/notice.png" alt="最新情報" /></router-link></li>
        <li><router-link :to="{ name: 'PointPurchase' }"><img src="/assets/img/header/purchase.png" alt="PT購入" /></router-link></li>
        <li><router-link :to="{ name: 'MailList' }"><img src="/assets/img/header/result.png" alt="鑑定結果" /></router-link></li>
        <li><router-link to="/"><img src="/assets/img/header/top.png" alt="TOP" /></router-link></li>
      </ul>
      <ul v-else class="pl-0">
        <li><img src="/assets/img/header/notice.png" alt="最新情報" /></li>
        <li><img src="/assets/img/header/purchase.png" alt="PT購入" /></li>
        <li><img src="/assets/img/header/result.png" alt="鑑定結果" /></li>
        <li><router-link to="/"><img src="/assets/img/header/top.png" alt="TOP" /></router-link></li>
      </ul>
    </nav>
    <div class="header_user_info" v-if="user.user != null">
      <p class="header_user_point base_text_style">
        <span>所持ポイント</span>
        <span class="header_user_current_point">{{ user.point.total.toLocaleString() }}pt</span>
      </p>
      <div class="header_mail_box">
        <p>
          <router-link :to="{ name: 'MailList' }" class="btn arrow">
            <div class="header_btn"><v-icon color="btn_main_font" class="mr-2">mdi-email-outline</v-icon>鑑定結果BOX</div>
          </router-link>
        </p>
        <span v-if="user.messageUnreadCount > 0">{{ user.messageUnreadCount }}</span>
      </div>
    </div>
  </header>
</template>

<script>
import { SET_SCROLL_POSITION } from '@/store/common/mutations'
import { SERVICE_CODE } from '@/common/config'

export default {
  name: 'Header',
  props: {
    isShowLogo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      sPosition: this.$store.getters.scrollPosition || null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    scrollPosition () {
      return this.$store.getters.scrollPosition
    },
    isShowHeader () {
      return location.pathname.replace(/\/+$/, '').split('/').pop().match('message')
    }
  },
  methods: {
    scrollToPosition (position) {
      // 使用したら null で初期化しておく
      this.$store.commit(SET_SCROLL_POSITION, null)

      const offsetHeight = this.$refs.header.offsetHeight
      window.scrollTo({
        top: position - offsetHeight,
        behavior: 'smooth'
      })
    },
    checkService () {
      return new Promise(() => {
        setTimeout(() => {
          if (this.user.user.setting_id !== Number(SERVICE_CODE)) {
            const html = document.getElementsByTagName('html')
            html[0].style.display = 'none'
            this.$store.dispatch('getDefaultSetting')
              .then((data) => {
                window.location.href = 'https://' + data.front_fqdn
              })
          }
        }, 100)
      })
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    scrollPosition (val) {
      if (val) {
        this.scrollToPosition(val)
      }
    }
  },
  async created () {
    await this.checkService()
  }
}
</script>
